/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @nx/enforce-module-boundaries */
import dynamic from 'next/dynamic';
import { Container, MapTo } from '@adobe/aem-react-editable-components';

/* eslint-disable @nx/enforce-module-boundaries */
import '../../libs/aemComponents/Container'; // TODO: Why are these imports not aliased?
import '../../libs/aemComponents/ExperienceFragment';
import {
  EditableHTLWrapper,
  // LinkList,
  NavigationUtilityLinkWrapper,
  NavigationWrapper,
} from '@marriott/mi-common-static-components';
import { ONavigationSide, OchatEditable, ONavigationContainer } from '@marriott/mi-chat-components';
import { OChatSignedOut } from '@marriott/mi-chat-components';
import { OResults } from '@marriott/mi-chat-components';
import { MConversationalNavGroupVertical } from '@marriott/mi-chat-components';
import { FlyoutDrawer } from '@marriott/mi-book-components';
import { AccountContainerEditable, SignInEditable, SignInContentBlockEditable } from '@marriott/mi-account-components';
import { respGridUtil } from '@marriott/mi-headless-utils';
import { getAllowedComponentsForNonAuthorMode as getAllowedComponentsForNonAuthorModeUtil } from '@marriott/shared/mi-helper-utils';

import { HotelInformationComponentEditable } from '../../libs/mi-shop-components/src/organisms/HotelInformation/HotelInformationComponent';
import { HotelOverviewComponentEditable } from '../../libs/mi-shop-components/src/organisms/HotelOverview/HotelOverview';
import { HotelGalleryPhotoViewerComponentEditable } from '../../libs/mi-shop-components/src/organisms/HotelGalleryPhotoViewer/HotelGalleryPhotoViewerComponent';

/* eslint-enable @nx/enforce-module-boundaries */

const HotelGalleryTitleEditable = dynamic(() =>
  import('../../libs/mi-shop-components/src/organisms/HotelGalleryTitle/HotelGalleryTitle').then(
    mod => mod.HotelGalleryTitleEditable
  )
);

// TODO: AEM component paths are having issues when picked using ENV vars
// Needs to be investigated as tech debt
export const AEM_REACT_MAPPING = {
  [`mi-aem-homepage-spa/components/content/global-navigation`]: ONavigationContainer,
  [`mi-aem-homepage-spa/components/content/utilityNavigation`]: NavigationUtilityLinkWrapper,
  [`mi-aem-homepage-spa/components/content/primaryNavigation`]: NavigationWrapper,
  [`mi-aem-common-spa/components/experiencefragment`]: Container,
  ['mi-aem-utils/components/content/chat/o-navigation-side']: ONavigationSide,
  ['mi-aem-utils/components/content/chat/o-chat']: OchatEditable,
  ['mi-aem-utils/components/content/chat/o-chat-signed-out']: OChatSignedOut,
  ['mi-aem-utils/components/content/chat/o-results']: OResults,
  [`mi-aem-homepage-spa/components/content/universal-footer`]: MConversationalNavGroupVertical,
  [`mi-aem-shop-spa/components/content/hotelgallerytitle`]: HotelGalleryTitleEditable,
  [`mi-aem-shop-spa/components/content/hotelinformation`]: HotelInformationComponentEditable,
  [`mi-aem-shop-spa/components/content/hotelgalleryoverview`]: HotelOverviewComponentEditable,
  [`mi-aem-shop-spa/components/content/hotelgalleryphotoviewer`]: HotelGalleryPhotoViewerComponentEditable,
  [`mcom-book-spa/components/flyoutcontainer`]: FlyoutDrawer,
  [`mi-aem-account/components/content/accountcontainer`]: AccountContainerEditable,
  [`mi-aem-account/components/content/signin`]: SignInEditable,
  [`mi-aem-account/components/content/signincontentblock`]: SignInContentBlockEditable,
  [`mi-aem-account/components/content/datapagecomponent`]: Container,
};

export const AEM_REACT_TITLE_MAPPING = {
  'mi-aem-homepage-spa/components/content/global-navigation': 'Global Navigation',
  'mi-aem-homepage-spa/components/content/utilityNavigation': 'Utility Navigation',
  'mi-aem-homepage-spa/components/content/primaryNavigation': 'Primary Navigation',
  'mi-aem-common-spa/components/experiencefragment': 'Experience Fragment',
  'mi-aem-utils/components/content/chat/o-navigation-side': 'Navigation Side',
  'mi-aem-utils/components/content/chat/o-chat': 'Chat',
  'mi-aem-utils/components/content/chat/o-chat-signed-out': 'Chat Signed Out',
  'mi-aem-utils/components/content/chat/o-results': 'Results',
  'mi-aem-homepage-spa/components/content/universal-footer': 'Universal Footer',
  'mi-aem-shop-spa/components/content/hotelgallerytitle': 'Hotel Gallery Title',
  'mi-aem-shop-spa/components/content/hotelinformation': 'Hotel information',
  'mi-aem-shop-spa/components/content/hotelgalleryoverview': 'Hotel Gallery overview',
  'mi-aem-shop-spa/components/content/hotelgalleryphotoviewer': 'Hotel Gallery Photo Viewer',
  'mcom-book-spa/components/flyoutcontainer': 'Flyout Container',
  'mi-aem-account/components/content/accountcontainer': 'Account Container',
  'mi-aem-account/components/content/signin': 'Sign In',
  'mi-aem-account/components/content/signincontentblock': 'Sign In Content Block',
  'mi-aem-account/components/content/datapagecomponent': 'Data Page Component',
};

export const getAllowedComponentsForNonAuthorMode = model => {
  return getAllowedComponentsForNonAuthorModeUtil(model, AEM_REACT_MAPPING, AEM_REACT_TITLE_MAPPING);
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const defineComponentMapping = (
  allowedComponents,
  pagePath,
  isAuthorMode,
  currentLocale,
  isBulgariDomain,
  nextPublicBulgariUrl,
  pageProps
) => {
  const logger = global.loggerInstance?.('defineComponentMapping');
  const log = logger?.log || (() => {});
  const logError = logger?.error || (() => {});

  try {
    // MapTo(`mi-aem-common-spa/components/content/linklist`)(LinkList);
    MapTo(`mi-aem-homepage-spa/components/content/global-navigation`)(ONavigationContainer);
    MapTo(`mi-aem-utils/components/content/chat/o-chat-signed-out`)(OChatSignedOut);
    MapTo(`mi-aem-utils/components/content/chat/o-chat`)(OchatEditable);
    MapTo(`mi-aem-utils/components/content/chat/o-navigation-side`)(ONavigationSide);
    MapTo(`mi-aem-homepage-spa/components/content/utilityNavigation`)(NavigationUtilityLinkWrapper);
    MapTo(`mi-aem-homepage-spa/components/content/primaryNavigation`)(NavigationWrapper);
    MapTo(`mi-aem-utils/components/content/chat/o-results`)(OResults);
    MapTo(`mi-aem-homepage-spa/components/content/universal-footer`)(
      props => <MConversationalNavGroupVertical {...props} isAuthorMode={isAuthorMode} />,
      {
        emptyLabel: 'MConversationalNavGroupVertical',
        isEmpty: false,
      }
    );
    MapTo(`mi-aem-shop-spa/components/content/hotelgallerytitle`)(
      props => <HotelGalleryTitleEditable {...props} isAuthorMode={isAuthorMode} />,
      {
        emptyLabel: 'SmHotelGalleryTitle',
        isEmpty: false,
      }
    );
    MapTo(`mi-aem-shop-spa/components/content/hotelgalleryoverview`)(HotelOverviewComponentEditable, {
      emptyLabel: 'HotelOverviewComponentEditable',
      isEmpty: false,
    });
    MapTo(`mi-aem-shop-spa/components/content/hotelgalleryphotoviewer`)(HotelGalleryPhotoViewerComponentEditable, {
      emptyLabel: 'HotelGalleryPhotoViewerComponentEditable',
      isEmpty: false,
    });
    MapTo(`mi-aem-shop-spa/components/content/hotelinformation`)(
      props => <HotelInformationComponentEditable {...props} isAuthorMode={isAuthorMode} />,
      {
        emptyLabel: 'HotelInformationComponent',
        isEmpty: false,
      }
    );

    MapTo(`mcom-book-spa/components/flyoutcontainer`)(
      props => <FlyoutDrawer {...props.model} {...props} isAuthorMode={isAuthorMode} />,
      {
        emptyLabel: 'FlyoutDrawer',
        isEmpty: false,
      }
    );
    MapTo(`mi-aem-account/components/content/accountcontainer`)(
      props => <AccountContainerEditable {...props} isAuthorMode={isAuthorMode} />,
      {
        emptyLabel: 'accountcontainer',
        isEmpty: false,
      }
    );
    MapTo(`mi-aem-account/components/content/signin`)(
      props => <SignInEditable {...props} isAuthorMode={isAuthorMode} />,
      {
        emptyLabel: 'signin',
      }
    );
    MapTo(`mi-aem-account/components/content/signincontentblock`)(
      props => <SignInContentBlockEditable {...props} isAuthorMode={isAuthorMode} />,
      {
        emptyLabel: 'signincontentblock',
      }
    );
    const DataPageVariationConfig = {
      emptyLabel: 'Data Page',

      isEmpty: function (props) {
        return !props || !props.configured;
      },
    };
    MapTo('mi-aem-account/components/content/datapagecomponent')(props => {
      const gridItems = props?.model?.cqItems?.responsivegrid?.[':items'];
      const isAccountContainer = gridItems ? Object.keys(gridItems)?.[0]?.includes('accountcontainer') : false;

      return (
        <Container
          isInEditor
          {...props}
          isPage={false}
          model={isAccountContainer ? respGridUtil(props?.model?.cqItems?.responsivegrid) : props?.model}
        />
      );
    }, DataPageVariationConfig);

    const existingMappings = Object.keys(AEM_REACT_MAPPING);

    // Validate allowedComponents before processing
    if (allowedComponents && Array.isArray(allowedComponents)) {
      let successCount = 0;
      let failureCount = 0;

      allowedComponents.forEach((mapping, index) => {
        try {
          // Validate mapping object structure
          if (!mapping || typeof mapping !== 'object') {
            throw new Error(`Invalid mapping object at index ${index}`);
          }

          if (!mapping.path || typeof mapping.path !== 'string') {
            throw new Error(`Invalid or missing path in mapping at index ${index}`);
          }

          const baseModelPath = '/jcr:content/root/responsivegrid/';
          const componentPath = mapping.path.replace(pagePath, '').replace(baseModelPath, '');

          if (!componentPath) {
            throw new Error(`Unable to extract component path from: ${mapping.path}`);
          }

          if (existingMappings.indexOf(componentPath) === -1) {
            MapTo(componentPath)(EditableHTLWrapper, {
              emptyLabel: mapping.title || 'Component',
              isEmpty: false,
            });
            successCount++;
          } else {
            if (process.env.NODE_ENV === 'development') {
              log('Mapping already exists, skipping:', componentPath);
            }
          }
        } catch (mappingError) {
          failureCount++;
          if (process.env.NODE_ENV === 'development') {
            logError(`Failed to map component at index ${index}:`, {
              error: mappingError.message,
              mapping: mapping,
              stack: mappingError.stack,
            });
          }
          // Continue processing remaining components
        }
      });

      if (process.env.NODE_ENV === 'development') {
        log(
          `Component mapping complete. Success: ${successCount}, Failed: ${failureCount}, Total: ${allowedComponents.length}`
        );
      }
    } else if (process.env.NODE_ENV === 'development') {
      log('No allowed components provided or invalid format');
    }
  } catch (err) {
    // Always log errors regardless of environment - use your server logger, not console
    logError('Critical error in defineComponentMapping:', {
      error: err.message,
      stack: err.stack,
    });
    // Re-throw so the caller (page bootstrap) can decide recovery strategy.
    // Silent failure here means EVERY AEM component renders as blank with zero observability.
    throw err;
  }
};
